var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',[_c('img',{staticClass:"team-logo",attrs:{"src":("https://s3.amazonaws.com/bookmkrs/img/logos/mini/" + _vm.id + ".png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }